//@flow
export const StyleEnum = Object.freeze({ 'photoRealistic': 0, 'cartoon': 1 })